import React, { useMemo } from 'react';

import Question from 'containers/Student/Exams/Profile/View/Upload/Question';

const Upload = ({ answers }) => {
	const noTitle = useMemo(() => answers?.length <= 1, [answers.length]);

	return (
		<div className="space-y-4">
			{answers?.map((question, idx) =>
				<Question
					key={question?.id}
					idx={idx}
					question={question}
					noTitle={noTitle}
				/>
			)}
		</div>
	);
};

export default Upload;